import styled from "styled-components/macro";

import { space, breakpoint } from "shared/styles/constants";
import { ButtonContainer } from "shared/components/Button/ButtonContainer";
import { IFormFieldStyle } from "shared/types";

export interface FormFieldContainerProps {
  style?: IFormFieldStyle;
}

export const FormFieldContainer = styled.div<FormFieldContainerProps>`
  display: grid;
  grid-gap: ${space.m} ${space.s};
  align-content: start;
  align-items: start;

  ${breakpoint("s", "down")} {
    ${({ style }) => {
      if (style?.mobile) {
        const { gridTemplateColumns, gridTemplateRows } = style.mobile;

        return `
            ${
              gridTemplateColumns
                ? `grid-template-columns: ${style.mobile.gridTemplateColumns} !important;`
                : ""
            }
            
            ${
              gridTemplateRows
                ? `grid-template-rows: ${style.mobile.gridTemplateRows} !important;`
                : ""
            }
          `;
      }
    }}
  }
`;

export interface FormContainerProps {
  inlineForm?: boolean;
  outsideForm?: boolean;
}

export const FormContainer = styled.form<FormContainerProps>`
  max-width: 100%;

  ${({ inlineForm }) =>
    inlineForm &&
    `
     display: grid;
     grid-template-columns: 1fr auto;
     grid-gap: ${space.s};
     align-items: end;

     ${breakpoint("s", "down")} {
           grid-template-columns: 1fr;
     }}

    `}
`;

interface FormButtonContainerProps {
  hasMargin?: boolean;
}

export const FormButtonContainer = styled(
  ButtonContainer
)<FormButtonContainerProps>`
  ${({ hasMargin }) => hasMargin && `margin-top: ${space.m} !important`};
`;
